import React from 'react'
import { isBrowser } from 'react-device-detect'
import FooterDesktop from './FooterDesktop'
import FooterMobile from './FooterMobile'

/**
 * Componente Footer que renderiza la sección de pie de página en la aplicación.
 * @returns {JSX.Element} Componente Footer.
 */
const Footer = () => {
	const information = [
		{
			description: 'Nosotros',
			link: ''
		},
		{
			description: 'Contáctenos',
			link: ''
		},
		{
			description: 'Plan de premios',
			link: ''
		},
		{
			description: 'Términos y condiciones',
			link: 'https://firebasestorage.googleapis.com/v0/b/merca-z-56017.appspot.com/o/legal%2FPL-01%20Manual%20Interno%20de%20Politicas%20y%20Procedimientos.pdf?alt=media&token=3f141e17-2a9b-44f5-8a78-86d5a9f386b1'
		},
		{
			description: 'Sedes',
			link: ''
		},
		{
			description: 'Tratamiento de datos',
			link: 'https://firebasestorage.googleapis.com/v0/b/merca-z-56017.appspot.com/o/legal%2FAUTORIZACIO%CC%81N%20PARA%20EL%20TRATAMIENTO%20DE%20DATOS%20PERSONALES..pdf?alt=media&token=4fb0b11e-aec9-4e93-89ad-268f8b02fc31'
		},
		{
			description: 'PQRS',
			link: 'https://www.mercaz.com.co/pqrs'
		},
		{
			description: 'Superintendencia de Industria y Comercio',
			link: 'https://www.sic.gov.co/'
		}
	]

	const FooterLayout = isBrowser ? FooterDesktop : FooterMobile
	return <FooterLayout information={information} />
}

export default Footer
